const getFieldsByDocumentType = (type: string) => {
  const isMainDocument = type === 'main'

  if (isMainDocument) {
    return ['title', 'longTitle', 'description', 'code', 'effectiveAt']
  }

  return [
    'title',
    'longTitle',
    'description',
    'code',
    'effectiveAt',
    'targetGroup',
    'legalEntities',
    'departments',
    'countries',
    'locations',
    'keywords',
    'certificationScope',
    'collections',
    'contact',
  ]
}

export default getFieldsByDocumentType
